import React from "react";

export function TradeRocketSvg({ tone = "up" }) {
  const isUp = tone === "up";
  const primaryColor = isUp ? "#00c076" : "#f6465d";
  const secondaryColor = isUp ? "#26e699" : "#ff6b7e";
  const glowColor = isUp ? "rgba(0, 192, 118, 0.8)" : "rgba(246, 70, 93, 0.8)";
  const flameOuter = isUp ? "#00ff9d" : "#ff3b30";
  const flameInner = isUp ? "#c2ffea" : "#ffd4d8";

  return (
    <svg
      viewBox="0 0 38 20"
      width="34"
      height="18"
      className="order-time-segment__rocket-svg"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={`rocket-hull-${tone}`} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#121721" />
          <stop offset="45%" stopColor="#1e2736" />
          <stop offset="100%" stopColor="#2a364a" />
        </linearGradient>
        <linearGradient id={`rocket-accent-${tone}`} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor={primaryColor} />
          <stop offset="100%" stopColor={secondaryColor} />
        </linearGradient>
        <linearGradient id={`rocket-flame-${tone}`} x1="1" y1="0" x2="0" y2="0">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="35%" stopColor={flameInner} />
          <stop offset="100%" stopColor={flameOuter} stopOpacity="0" />
        </linearGradient>
        <filter id={`rocket-glow-${tone}`} x="-20%" y="-40%" width="150%" height="180%">
          <feDropShadow dx="0" dy="0" stdDeviation="2" floodColor={glowColor} floodOpacity="0.75" />
        </filter>
      </defs>

      {/* Pulsing thruster plasma flame */}
      <g className="order-time-rocket-exhaust">
        <polygon
          points="13,7 2,10 13,13 8,10"
          fill={`url(#rocket-flame-${tone})`}
          className="order-time-flame-outer"
        />
        <polygon
          points="13,8.5 5,10 13,11.5"
          fill="#ffffff"
          opacity="0.95"
          className="order-time-flame-core"
        />
      </g>

      {/* Aerodynamic delta wings */}
      <path
        d="M13 4 L18 9 L11 10 L18 11 L13 16 L10 12 L7 10 L10 8 Z"
        fill="#0b0f17"
        stroke={primaryColor}
        strokeWidth="0.8"
      />

      {/* Main Hull Body (fuselage) */}
      <path
        d="M11 7 C18 7, 27 8.5, 34 10 C27 11.5, 18 13, 11 13 C9.5 13, 9.5 7, 11 7 Z"
        fill={`url(#rocket-hull-${tone})`}
        stroke={secondaryColor}
        strokeWidth="1"
        filter={`url(#rocket-glow-${tone})`}
      />

      {/* Neon energy racing stripe */}
      <path
        d="M14 10 L28 10"
        stroke={`url(#rocket-accent-${tone})`}
        strokeWidth="1.2"
        strokeLinecap="round"
      />

      {/* Glass Cockpit Canopy */}
      <path
        d="M21 8.5 C25 9, 28 9.5, 30 10 C28 10.5, 25 11, 21 11.5 C20 10.5, 20 9.5, 21 8.5 Z"
        fill={isUp ? "#e6fff5" : "#ffebeb"}
        opacity="0.95"
      />

      {/* Direction micro-arrow indicator */}
      {isUp ? (
        <polygon points="26,8.2 28.5,8.2 28.5,10.7" fill="#00c076" />
      ) : (
        <polygon points="26,11.8 28.5,11.8 28.5,9.3" fill="#f6465d" />
      )}
    </svg>
  );
}

